import { client } from '@core/api/API'

export default {
  async fetchCountries() {
    return await client.get('/location/countries')
  },

  async fetchStates(params) {
    return await client.get('/location/states', {
      params,
    })
  },

  async fetchCities(params) {
    return await client.get('/location/cities', {
      params,
    })
  },
}
